import { useFrame } from "@react-three/fiber";
import { useRef } from "react";

function Sun() {
  const sunRef = useRef();
  const lightRef = useRef();

  useFrame(() => {
    if (sunRef.current) {
      sunRef.current.rotation.y += 0.005;
    }

    if (lightRef.current) {
      const intensity = 2 + Math.sin(Date.now() * 0.001) * 0.2;
      lightRef.current.intensity = intensity;
    }
  });

  return (
    <group>
      <mesh ref={sunRef} position={[0, 0, 0]} castShadow>
        <sphereGeometry args={[0.8, 32, 32]} />
        <meshBasicMaterial color="#FDB813" />
      </mesh>

      {/* Main directional light for shadows */}
      <directionalLight
        ref={lightRef}
        position={[0, 0, 0]}
        intensity={2}
        castShadow
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-far={50}
        shadow-camera-left={-20}
        shadow-camera-right={20}
        shadow-camera-top={20}
        shadow-camera-bottom={-20}
      />

      {/* Point light for overall illumination */}
      <pointLight
        position={[0, 0, 0]}
        intensity={1.5}
        distance={50}
        decay={0.1}
      />
    </group>
  );
}

export default Sun;
